var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0075 0.511719L9.49333 9.00005L1.00833 17.4884C0.857452 17.425 0.728691 17.3183 0.638244 17.1819C0.547796 17.0455 0.499699 16.8854 0.500001 16.7217V1.27839C0.500065 1.1149 0.548214 0.95505 0.638452 0.818729C0.728691 0.682408 0.857034 0.57564 1.0075 0.511719ZM10.0825 9.58922L12.0008 11.5076L2.88667 16.7851L10.0825 9.58922ZM12.7483 6.92422L15.0875 8.27922C15.2138 8.35247 15.3186 8.45762 15.3915 8.58412C15.4643 8.71063 15.5027 8.85406 15.5027 9.00005C15.5027 9.14604 15.4643 9.28947 15.3915 9.41598C15.3186 9.54249 15.2138 9.64763 15.0875 9.72089L12.7475 11.0759L10.6717 9.00005L12.7483 6.92422ZM2.88667 1.21505L12.0017 6.49172L10.0825 8.41089L2.88667 1.21505Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayWhite);
export default __webpack_public_path__ + "static/media/google-play-white.7ec4f526b2e84c89f64a7844ae2eee23.svg";
export { ForwardRef as ReactComponent };